import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject} from "rxjs";
import {ConstantsService} from "../fidelidade/ConstantsService";
import {ServerService} from "./ServerService";
import {ArmazenamentoService} from "./armazenamento.service";

@Injectable({
  providedIn: 'root'
})
export class AutorizacaoService  extends ServerService {
  kEYUSER = 'pkuser';
  private usuarioLogado = new BehaviorSubject<any>(null);
  usuarioLogado$ = this.usuarioLogado.asObservable();

  constructor (public http: HttpClient, private constantsService: ConstantsService,
               private armazenamentoService: ArmazenamentoService) {
    super(http);
    this.estaLogado().then((resposta: any) => {
      if(!resposta.logado ) {
        this.limpeSessaoLocal();
        return;
      }

      this.usuarioLogado.next(this.getUsuario());
    })
  }

  estaLogado(): Promise<boolean> {
    return new Promise(resolve => {
      this.http.get('/auth/logado').subscribe((resposta: any) => {
        resolve(resposta);
      });
    });
  }

  getUsuario() {
    let _user = this.armazenamentoService.carregue(this.kEYUSER, false);

    if(!_user)
      return null;

    return JSON.parse(_user);
  }

  async obtenhaPapeis(){
    return new Promise(resolve => {
      this.http.get('/auth/usuario/papeis/me').subscribe((resposta: any) => {
        let papeis = resposta.data;

        if(papeis && papeis.length){
          let usuario: any = this.getUsuario();
          usuario.papeis = papeis;
          this.armazenamentoService.salveSemExpirar(this.kEYUSER, JSON.stringify(usuario));
        }

        resolve(papeis);
      });
    });
  }

  login(email: string, senha: string): Promise <Object> {
    return new Promise(resolve => {
      this.http.post('/auth/login', {user: {email: email, password: senha}}).subscribe((resposta: any) => {
        if(resposta.sucesso) {
          const usuario: any = {};

          Object.assign(usuario, resposta.data);

          this.armazenamentoService.salveSemExpirar(this.kEYUSER, JSON.stringify(usuario));

          this.usuarioLogado.next(usuario);


        }

        resolve(resposta.erro);
      });
    });
  }

  cadastrar(nome: string, email: string, senha: string): Promise<Object> {
    return new Promise(resolve => {
      this.http.post('/usuario/', {user: {nome: nome, email: email, senha: senha}}).subscribe((resposta: any) => {
        if(resposta.sucesso) {
          let usuario: any = {};

          Object.assign(usuario, resposta.usuario);

          this.armazenamentoService.salveSemExpirar(this.kEYUSER, JSON.stringify(usuario))

        }

        resolve(resposta)
      })

    })
  }

  limpeSessaoLocal() {
    this.armazenamentoService.remova('idm2');
    this.armazenamentoService.remova(this.kEYUSER);
  }

  logout(): Promise<boolean> {
    return new Promise(resolve => {
      this.http.post('/auth/logout', {}).subscribe((resposta: any) => {
        if(resposta.sucesso) {
          this.limpeSessaoLocal();

          return resolve(null)
        }

        resolve(false)
      });

    })
  }

  atualizeUsuario(usuario: any) {
    this.armazenamentoService.salveSemExpirar(this.kEYUSER, JSON.stringify(usuario));

    this.usuarioLogado.next(usuario);
  }

  envieEmailRecuperacao(email: any) {
    return this.http.post('/auth/usuario/recuperar', {email: email})
      .toPromise().then(this.retorno).catch(this.handleError);
  }


  troqueSenha(token: string, senha: string): Promise <any> {
    return this.http.put('/auth/usuario/troquesenha/' + token, {senha: senha})
      .toPromise().then(this.retorno).catch(this.handleError);
  }

  verifiqueCodigoConfirmacao(token: any, codigo: any) {

    return this.http.post('/auth/token/verifique/' + token, {codigo: codigo})
      .toPromise().then(this.retorno).catch(this.handleError);

  }

  obtenhaToken(token: any) {
    return this.http.get('/auth/token/' + token)
      .toPromise().then(this.retorno).catch(this.handleError);
  }
}
